import { Controller } from '@hotwired/stimulus';
import inputStates from '../../modules/validate/inputStates';

export default class extends Controller {
  connect () {
    inputStates();
  }
}
